var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23223 4.23223C2.70107 3.76339 3.33696 3.5 4 3.5H11C11.2761 3.5 11.5 3.72386 11.5 4C11.5 4.27614 11.2761 4.5 11 4.5H4C3.60218 4.5 3.22064 4.65804 2.93934 4.93934C2.65804 5.22064 2.5 5.60218 2.5 6V20C2.5 20.3978 2.65804 20.7794 2.93934 21.0607C3.22064 21.342 3.60218 21.5 4 21.5H18C18.3978 21.5 18.7794 21.342 19.0607 21.0607C19.342 20.7794 19.5 20.3978 19.5 20V13C19.5 12.7239 19.7239 12.5 20 12.5C20.2761 12.5 20.5 12.7239 20.5 13V20C20.5 20.663 20.2366 21.2989 19.7678 21.7678C19.2989 22.2366 18.663 22.5 18 22.5H4C3.33696 22.5 2.70107 22.2366 2.23223 21.7678C1.76339 21.2989 1.5 20.663 1.5 20V6C1.5 5.33696 1.76339 4.70107 2.23223 4.23223Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.37891C19.57 2.37891 19.1576 2.54972 18.8535 2.85378L9.45148 12.2559L8.68718 15.313L11.7444 14.5487L21.1464 5.14667C21.4505 4.84262 21.6213 4.43023 21.6213 4.00023C21.6213 3.57023 21.4505 3.15784 21.1464 2.85378C20.8424 2.54972 20.43 2.37891 20 2.37891ZM18.1464 2.14667C18.638 1.65508 19.3048 1.37891 20 1.37891C20.6952 1.37891 21.362 1.65508 21.8535 2.14667C22.3451 2.63827 22.6213 3.30501 22.6213 4.00023C22.6213 4.69544 22.3451 5.36219 21.8535 5.85378L12.3535 15.3538C12.2895 15.4179 12.2092 15.4633 12.1213 15.4853L8.12126 16.4853C7.95088 16.5279 7.77063 16.478 7.64644 16.3538C7.52225 16.2296 7.47233 16.0493 7.51492 15.879L8.51492 11.879C8.5369 11.791 8.58236 11.7108 8.64644 11.6467L18.1464 2.14667Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.eba15133d3695459156e50f9e37b6f06.svg";